import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';
import AppAlertBanner from '../../common/AppAlertBanner';
import { currencyFormat, formatUtcDate } from '../../../helpers/format';

const StoreAlertBanner = ({ ecomStore }) => {
  const { state: authState } = useContext(AuthContext);
  const { state } = useContext(StoreContext);
  const [hideAlert, setHideAlert] = useState(false);
  const setupSummary =
    state.ecomStoreSetupSummary.value?.ecomStore.pkEcomStore.toString() ===
    authState.pkEcomStore?.toString()
      ? state.ecomStoreSetupSummary.value
      : null;
  const loading = !ecomStore || !setupSummary;

  const today = new Date();
  const threeDaysFromNow = new Date(today);
  threeDaysFromNow.setDate(today.getDate() + 3);
  threeDaysFromNow.setHours(0, 0, 0, 0);

  useEffect(() => {
    if (authState.pkEcomStore) {
      setHideAlert(false);
    }
  }, [authState.pkEcomStore]);

  return (
    !loading &&
    !hideAlert &&
    (setupSummary?.escrowBalance > 0 ? (
      <AppAlertBanner
        backgroundColor="#067D62"
        linkText="Click here to claim."
        linkTo="/merchant/escrow-payments?modal=claim"
        message={`Your store has a balance of ${currencyFormat(
          state.ecomStoreSetupSummary.value.escrowBalance / 100
        )} available to claim.`}
        onClose={() => setHideAlert(true)}
      />
    ) : (
      !ecomStore.sandboxEnabled &&
      (!ecomStore.ecomStoreWindow ? (
        <AppAlertBanner
          linkText="Click here to setup."
          linkTo="/merchant/settings?modal=sales-window"
          message="Your store is currently disabled. You must create a sales window before you can start selling."
          onClose={() => setHideAlert(true)}
        />
      ) : (
        new Date(formatUtcDate(ecomStore.ecomStoreWindow.closeDate)) <
          threeDaysFromNow && (
          <AppAlertBanner
            backgroundColor="#eca70a"
            linkText="Click here to extend."
            linkTo="/merchant/settings?modal=sales-window"
            message="Your store is about to close. Extend your sales window to keep selling."
            onClose={() => setHideAlert(true)}
          />
        )
      ))
    ))
  );
};

StoreAlertBanner.propTypes = { ecomStore: PropTypes.object };

export default StoreAlertBanner;
